import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { AppendJsonRequest, ArchiveReturnJsonRequest, AssignReturnsJsonRequest, ChangeDocumentStatusJsonRequest, CommonJsonRequest, DeleteRecycleBinReturnJsonRequest, DeleteReturnJsonRequest, InProcessReturnJsonRequest, PartialUploadJsonRequest, RecallReturnJsonRequest, RecognizeReturnJsonRequest, ResendAccessLinkJsonRequest, RestoreRecycleBinReturnJsonRequest, SendReminderJsonRequest, SetAccessJsonRequest, SetDownloadStatusJsonRequest, SSR_ArchivedReturn_commonJsonRequest, SSR_ArchivedReturn_ResendAccessLinkJsonRequest, SSR_ArchivedReturn_SendReminderJsonRequest, UploadJsonRequest } from "../../common/model/ssr/jsonRequest";
import { generateCallbackCurlCommand, generateCurlCommand, generateNoBodyCurlCommand } from "../helperFunctions";

const commonJsonRequest: CommonJsonRequest = {
  documents: ["string"],
  fileURLs: ["string"],
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
}

const appendJsonRequest: AppendJsonRequest = {
  ...commonJsonRequest,
  taxReturnId: "string",
}

export const appendJsonRequestCurl = generateCurlCommand(
  SSR.RETURNS.APPEND_URL,
  "POST",
  appendJsonRequest
);

export const fetchReturnDetailsJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.RETURNS.FETCH_RETURN_DETAILS_URL,
  "GET",
);

const partialUploadJsonRequest: PartialUploadJsonRequest = {
  ...commonJsonRequest,
  taxSoftware: 0,
  rid: "string",
  clientId: "string",
}

export const partialUploadJsonRequestCurl = generateCurlCommand(
  SSR.RETURNS.PARTIAL_UPLOAD_URL,
  "POST",
  partialUploadJsonRequest
);

const recognizeReturnJsonRequest: RecognizeReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string",
}

export const recognizeReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.RETURNS.RECOGNIZE_URL,
  "POST",
  recognizeReturnJsonRequest
);

const setAccessJsonRequest: SetAccessJsonRequest = {
  taxReturnId: "string",
  assignedTo: [0],
}

export const setAccessJsonRequestCurl = generateCurlCommand(
  SSR.RETURNS.SET_ACCESS_URL,
  "PUT",
  setAccessJsonRequest
);

export const unRecognizedReturnsJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.RETURNS.UN_RECOGNIZED_RETURNS_URL,
  "GET",
);

const uploadJsonRequest: UploadJsonRequest = {
  ...commonJsonRequest,
  rid: "string",
  clientId: "string",
  delayRecognition: true,
  taxSoftware: 0,
  callbackUri: "string",
}

export const uploadJsonRequestCurl = generateCallbackCurlCommand(
  SSR.RETURNS.UPLOAD_URL,
  "POST",
  uploadJsonRequest
);

export const uploadedReturnsJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.RETURNS.UPLOADED_RETURNS_URL,
  "GET",
);

const assignReturnsJsonRequest: AssignReturnsJsonRequest = {
  taxReturnIds: ["string"],
  userId: 0
}

export const assignReturnJsonRequestCurl = generateCurlCommand(
  SSR.IN_PROCESS.ASSIGN_RETURNS_URL,
  "PUT",
  assignReturnsJsonRequest
);

const changeDocumentStatusJsonRequest: ChangeDocumentStatusJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string",
  documentStatus: 0
}

export const changeDocumentStatusJsonRequestCurl = generateCallbackCurlCommand(
  SSR.IN_PROCESS.CHANGE_DOCUMENTS_STATUS_URL,
  "PUT",
  changeDocumentStatusJsonRequest
);

const inProcessReturnJsonRequest: InProcessReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string"
}

export const inProcessReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.IN_PROCESS.IN_PROCESS_RETURN_DELETE_URL,
  "DEL",
  inProcessReturnJsonRequest
);

export const inProcessReturnsJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.IN_PROCESS.IN_PROCESS_RETURNS_URL,
  "GET",
);

const deleteRecycleBinReturnJsonRequest: DeleteRecycleBinReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string"
}

export const deleteRecycleBinReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.RECYCLE_BIN.DELETE_RECYCLE_BIN_RETURN_URL,
  "DEL",
  deleteRecycleBinReturnJsonRequest
);

export const recycleBinReturnJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.RECYCLE_BIN.RECYCLE_BIN_RETURN_URL,
  "GET",
);

const restoreRecycleBinReturnJsonRequest: RestoreRecycleBinReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string"
}

export const restoreRecycleBinReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.RECYCLE_BIN.RESTORE_RECYCLE_BIN_RETURN_URL,
  "PUT",
  restoreRecycleBinReturnJsonRequest
);

const archiveReturnJsonRequest: ArchiveReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string"
}

export const archiveReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.DELIVERED.ARCHIVE_RETURN_URL,
  "PUT",
  archiveReturnJsonRequest
)

export const accessLinkJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.DELIVERED.ACCESS_LINK_URL,
  "GET",
)

const deleteReturnJsonRequest: DeleteReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string",
}

export const deleteReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.DELIVERED.DELETE_RETURN_URL,
  "DEL",
  deleteReturnJsonRequest
)

const recallReturnJsonRequest: RecallReturnJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string",
}

export const recallReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.DELIVERED.RECALL_RETURN_URL,
  "PUT",
  recallReturnJsonRequest
)

export const deliveredReturnJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.DELIVERED.DELIVERED_RETURN_URL,
  "GET",
)

export const eFileFormJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.DELIVERED.E_FILE_FORMS_URL,
  "GET",
)

export const signatureStatusJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.DELIVERED.SIGNATURE_STATUS_URL,
  "GET",
)

export const signerInfoJsonRequest = generateNoBodyCurlCommand(
  SSR.DELIVERED.SIGNER_INFORMATION_URL,
  "GET",
)

const resendAccessLinkJsonRequest: ResendAccessLinkJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  signerGuid: "string"
}

export const resendAccessLinkJsonRequestCurl = generateCurlCommand(
  SSR.DELIVERED.RESEND_ACCESS_LINK_URL,
  "POST",
  resendAccessLinkJsonRequest
)

const sendReminderJsonRequest: SendReminderJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
}

export const sendReminderJsonRequestCurl = generateCurlCommand(
  SSR.DELIVERED.SEND_REMINDER_URL,
  "POST",
  sendReminderJsonRequest
)

const setDownloadStatusJsonRequest: SetDownloadStatusJsonRequest = {
  taxReturnId: "string",
}

export const setDownloadStatusJsonRequestCurl = generateCurlCommand(
  SSR.RETURN_STATUS.SET_DOWNLOAD_STATUS_URL,
  "PUT",
  setDownloadStatusJsonRequest
)

export const SSR_ArchivedReturn_getAccessLinkJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.ARCHIVED.ACCESS_LINK_URL,
  "GET",
)

export const SSR_ArchivedReturn_ArchivedReturnsJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.ARCHIVED.ARCHIVED_RETURNS_URL,
  "GET",
)

const SSR_ArchivedReturnAPI_commonJsonRequest: SSR_ArchivedReturn_commonJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  callbackUri: "string"
}

export const SSR_ArchivedReturnAPI_DeleteReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.ARCHIVED.DELETE_RETURN_URL,
  "DEL",
  SSR_ArchivedReturnAPI_commonJsonRequest
)

export const SSR_ArchivedReturnAPI_MoveToDeliveredJsonRequestCurl = generateCallbackCurlCommand(
  SSR.ARCHIVED.MOVE_TO_DELIVERED_URL,
  "PUT",
  SSR_ArchivedReturnAPI_commonJsonRequest
)

export const SSR_ArchivedReturnAPI_RecallReturnJsonRequestCurl = generateCallbackCurlCommand(
  SSR.ARCHIVED.RECALL_RETURN_URL,
  "PUT",
  SSR_ArchivedReturnAPI_commonJsonRequest
)

const SSR_ArchivedReturnAPI_ResendAccessLinkJsonRequest: SSR_ArchivedReturn_ResendAccessLinkJsonRequest = {
  taxReturnId: "string",
  correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  signerGuid: "string"
}

export const SSR_ArchivedReturnAPI_ResendAccessLinkJsonRequestCurl = generateCurlCommand(
  SSR.ARCHIVED.RESEND_ACCESS_LINK_URL,
  "POST",
  SSR_ArchivedReturnAPI_ResendAccessLinkJsonRequest
)

const SSR_ArchivedReturnAPI_SendReminderJsonRequest: SSR_ArchivedReturn_SendReminderJsonRequest = {
  "taxReturnId": "string",
  "correlationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
}

export const SSR_ArchivedReturnAPI_SendReminderJsonRequestCurl = generateCurlCommand(
  SSR.ARCHIVED.SEND_REMINDER_URL,
  "POST",
  SSR_ArchivedReturnAPI_SendReminderJsonRequest
)

export const SSR_ArchivedReturnAPI_SignatureStatusJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.ARCHIVED.SIGNATURE_STATUS_URL,
  "GET",
)

export const SSR_ArchivedReturnAPI_SignerInformationJsonRequestCurl = generateNoBodyCurlCommand(
  SSR.ARCHIVED.SIGNER_INFORMATION_URL,
  "GET",
)